var map = {
	"./be.json": 1350,
	"./be_nl.json": 5265,
	"./de.json": 1272,
	"./de_at.json": 4000,
	"./de_vf.json": 713,
	"./en.json": 5188,
	"./se.json": 4055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;